$(document).ready(function() {
    //Video Grid Modal
    $('.play-modal').click(function() {
        var video = $(this).attr("data-src");
        $('#video-modal').attr("src", video + "?showinfo=0&controls=1&enablejsapi=1&rel=0");
        $('body').addClass('modal-active');
    });
    $('#hero-video .exit').click(function() {
        $('body').removeClass('modal-active');
        //stop video if playing - delay for animation
        setTimeout(function() {
            $('#video-modal').attr("src", "");
        }, 600);
    });
    $('#hero-video .hero-video-modal').click(function() {
        $('body').removeClass('modal-active');
        //stop video if playing - delay for animation
        setTimeout(function() {
            $('#video-modal').attr("src", "");
        }, 600);
    });
    //** Back to top
    var offset = 400,
        duration = 300,
        scrollspeed = 2000,
        bottomdist = 0,
        footeroffset = 0,
        scrollElement = document.createElement('div');
    scrollElement.setAttribute("id", "scrolltop");
    scrollElement.innerHTML = '<a href="#top"></a>';
    document.body.appendChild(scrollElement);
    //Fade Scroll element
    $(window).scroll(function() {
        if ($(this).scrollTop() > offset) {
            $('#scrolltop').fadeIn(duration);
        } else {
            $('#scrolltop').fadeOut(duration);
        }
        //footer position
        footeroffset = $('footer').outerHeight();
        bottomdist = $(document).height() - $(this).height() - $(this).scrollTop();
        if (bottomdist < footeroffset) {
            var scrolloffset = footeroffset - bottomdist;
            $('#scrolltop').css({ bottom: scrolloffset });
        } else {
            $('#scrolltop').css({ bottom: '' });
        }
    });
    //ScrollTop action
    $('#scrolltop').click(function(event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, scrollspeed);
        return false;
    });
    //universal
    $(".scrolllink").click(function() {
        var linkele = $(this).attr("data-link");
        $('html, body').animate({
            scrollTop: $(linkele).offset().top - 0
        }, 2000);
    });

    //Scroll Animations
    $(window).scroll(function() {
        if ($(this).scrollTop() > offset) {
            $('#scrolltop').fadeIn(duration);
        } else {
            $('#scrolltop').fadeOut(duration);
        }
        //Overview Section
        if (bottomdist < footeroffset) {
            var scrolloffset = footeroffset - bottomdist;
            $('#scrolltop').css({ bottom: scrolloffset });
        } else {
            $('#scrolltop').css({ bottom: '' });
        }
    });
});